import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ProductType } from '@core/models/api/dsm-types';
import { Nullable } from '@shared/utils/type.utils';
import { PriceSummaryDisplayProduct } from '../price-summary-display/price-summary-display-content';
import { Observable, take } from 'rxjs';
import { TaskService } from '@core/services/task.service';
import { ModalService } from '@shared/services/modal.service';
import { PaymentPlanDisplay } from '@shared/constants/billing-constants';
import { ProductModel } from '@entities/product/product.model';
import { PayBindFormService } from '@forms-store/services/pay-bind-form.service';

@Component({
    selector: 'nwx-product-display',
    templateUrl: './product-display.component.html',
    styleUrls: ['./product-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductDisplayComponent {
  @Input() product!: PriceSummaryDisplayProduct;
  @Input() awaitingProtectorVersionChoice: Nullable<boolean>;

  @Output() addUpsell = new EventEmitter<Nullable<ProductType>>();

  paymentPlans$!: Observable<PaymentPlanDisplay[]>;

  constructor(
    private taskService: TaskService,
    private modalService: ModalService,
    private payBindFormService: PayBindFormService
  ) {
    this.paymentPlans$ = this.payBindFormService.getPaymentPlanDisplays();
  }

  scrollToTasks(): void {
    this.taskService.setShowTasks(true);
    const div = document.querySelector('.tasks-container');
    if (div) div.scrollIntoView({ behavior: 'smooth' });
  }

  editPaymentPlan(displayProduct: PriceSummaryDisplayProduct): void {
    const product: ProductModel = {
      imageUrl: displayProduct.imageUrl,
      name: displayProduct.name,
      paymentPlan: displayProduct.paymentPlan,
      quoteId: displayProduct.quoteId,
      type: displayProduct.type || 'PersonalAuto',
    };
    this.modalService.paymentPlanModal(product, false, 'coverages');
  }

  getPaymentPlanDisplayName(paymentPlan: string): string {
    let displayName = '';
    this.paymentPlans$.pipe(take(1)).subscribe((paymentPlans) => {
      const paymentPlanDisplay = paymentPlans.find(
        (plan) => plan.value === paymentPlan
      );
      if (paymentPlanDisplay && paymentPlanDisplay.displayName) {
        displayName = paymentPlanDisplay.displayName;
        if (paymentPlanDisplay.hasDiscount) {
          displayName = displayName + ' | discount';
        }
      }
    });
    return displayName;
  }
}
